import React from 'react';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { ISubscription } from 'interfaces/IProductData';
import { SubscriptionWithTrial } from 'components/Cart/Price/Subscription/SubscriptionWithTrial';
import Translate from 'components/Translate';
import { paymentService } from 'services/PaymentService';

interface IProps {
  installments: number;
  price: number;
  subscription?: ISubscription;
}

export const Price = (props: IProps) => {
  if (props.subscription) {
    return (
      <div>
        {props.subscription.hasTax
          ? (
            <div className='chk-subscription'>
              <div className='chk-subscription__text'><Translate term='Adesão de' /></div>
              <div className='chk-subscription__value theme-label'>
                {props.installments > 1 ?
                  <div className='price'>{props.installments}x <CurrencyFormat value={props.price / props.installments} /></div> :
                  <div className='price'><CurrencyFormat value={props.price} /></div>
                }
              </div>
              <div className='chk-subscription__frequency'>
                + <CurrencyFormat value={props.subscription.price} />&nbsp;
                <Translate
                  // tslint:disable-next-line:max-line-length
                  term={`a cada {frequency} ${paymentService.getNormalizedFrequencyType(props.subscription.frequencyType, props.subscription.frequency)}`}
                  properties={
                    {
                      tax: <CurrencyFormat value={props.subscription.tax} />,
                      frequency: props.subscription.frequency
                    }
                  }
                />
              </div>
            </div>
          )
          : null
        }

        {props.subscription.hasTrial
          ? <SubscriptionWithTrial subscription={props.subscription} />
          : null
        }

        {!props.subscription.hasTax && !props.subscription.hasTrial
          ? (
            <div className='chk-subscription'>
              <div className='chk-subscription__text'><Translate term='Assinatura' /></div>
              <div className='chk-subscription__value theme-label'>
                {props.installments > 1 ?
                  <div className='price'>{props.installments}x <CurrencyFormat value={props.price / props.installments} /></div> :
                  <div className='price'><CurrencyFormat value={props.price} /></div>
                }
              </div>
              <div className='chk-subscription__frequency'>
                <Translate
                  // tslint:disable-next-line:max-line-length
                  term={`a cada {frequency} ${paymentService.getNormalizedFrequencyType(props.subscription.frequencyType, props.subscription.frequency)}`}
                  properties={
                    {
                      tax: <CurrencyFormat value={props.subscription.tax} />,
                      frequency: props.subscription.frequency
                    }
                  }
                />
              </div>
            </div>
          )
          : null
        }
      </div>
    );
  }

  if (props.installments > 1) {
    return <div className='price'>{props.installments}x <CurrencyFormat value={props.price / props.installments} /></div>;
  }

  return <div className='price'><CurrencyFormat value={props.price} /></div>;
};